import * as React from 'react'
import { Outlet } from 'react-router-dom'
import { BasicLayout } from '@/components/Layouts'
import useStyles from './AuthLayout.styles'

export const AuthLayout = () => {
  const { classes } = useStyles()

  return (
    <BasicLayout colorScheme>
      <div className={classes.wrapper}>
        <div className={classes.block}>
          <Outlet />
        </div>
      </div>
    </BasicLayout>
  )
}
